import React from "react";
import { ServicePage } from "@/components/ServicePage";
import { IllustratedExplainers } from "@/components/IllustratedExplainers";

export const Schwachstellen = () => (
  <ServicePage
    slotAfterFeatures={<IllustratedExplainers />}
    testIdSlug="schwachstellen"
    seo={{
      title: "Schwachstellenmanagement · Vulnerability Management",
      description: "Schwachstellenmanagement mit Greenbone & OpenVAS. Kontinuierliche Scans, CVSS-Bewertung, automatisierte Patch-Zyklen und audit-fähige Reports.",
      keywords: "Schwachstellenmanagement, Vulnerability Management, Greenbone, OpenVAS, CVSS, Patch Management, Penetration Test, Audit",
      serviceName: "Schwachstellenmanagement",
      breadcrumb: [
        { name: "Start", path: "/" },
        { name: "Schwachstellenmanagement", path: "/schwachstellenmanagement" },
      ],
    }}
    eyebrow="Schwachstellenmanagement"
    title="Schwachstellen erkennen, bevor andere es tun."
    subtitle="Kontinuierliche Scans mit Greenbone, Risikobewertung nach CVSS, automatisierte Patch-Zyklen und detaillierte Reports – Ihr Frühwarnsystem."
    heroImage="/wp-images/schwachstellenmanagement.jpg"
    features={[
      { title: "IT-Sicherheitsanalyse", desc: "Identifizieren Sie Schwachstellen in Systemen und reduzieren Sie Risiken effizient." },
      { title: "Risiko & Patch-Management", desc: "Software bleibt auf neuestem Stand – Lücken werden zeitnah geschlossen." },
      { title: "Schwachstellen-Monitoring", desc: "Kontinuierliche Überwachung Ihrer Systeme, um Bedrohungen früh zu erkennen." },
      { title: "Automatisierte Berichte", desc: "Regelmäßige, detaillierte Reports zur Überwachung und Nachverfolgung." },
      { title: "Risikobewertung", desc: "Schwachstellen priorisiert nach Bedrohungsgrad – CVSS-konform." },
      { title: "Compliance Support", desc: "Dokumentation für Audits, NIS-2 und DSGVO." },
    ]}
    steps={[
      { title: "Inventarisierung", body: "Alle IT-Systeme, Netzwerke, Anwendungen und Geräte werden erfasst – mit CMDB-Methodik." },
      { title: "Schwachstellen identifizieren", body: "Regelmäßige Scans mit Greenbone, OpenVAS und ergänzenden Tools." },
      { title: "Bewertung", body: "Analyse nach Auswirkung, Ausnutzbarkeit und betroffenen Systemen (CVSS)." },
      { title: "Behebung", body: "Patches, Konfigurationsänderungen und Gegenmaßnahmen werden umgesetzt." },
      { title: "Überprüfung & Dokumentation", body: "Verifikation der Behebung, Reporting via SIEM – audit-ready." },
      { title: "Kontinuierliche Verbesserung", body: "Regelmäßige Reviews und Anpassung an neue Bedrohungslagen." },
    ]}
    bullets={[
      "Umfassende Risikoanalyse",
      "Proaktive Schwachstellenbeseitigung",
      "Regelmäßige Sicherheitsupdates",
      "Detaillierte Berichterstattung",
      "Experten-Support rund um die Uhr",
      "Greenbone Vulnerability Management",
    ]}
    testimonials={[
      { quote: "Unser Schwachstellenmanagement hat unsere IT-Sicherheit auf ein neues Niveau gehoben.", name: "Stefan Müller", role: "IT-Manager" },
    ]}
  />
);
